import { useCallback, useMemo, useState } from 'react'
import ModalTabs from '../../../../../../../baseComponents/ModalsLayouts/ModalTabs'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { ComponentTabObject } from '../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { changeEmployeeParams, changeSuccessMessage } from '../../../../../../../utils/reducers/reduxDispatch'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'
import { ModalOpenedSetTy } from '../../../../../../../baseComponents/Modal/types'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import ModalConfigTurnWCColors from './ModalConfigTurnWCColors'
import { getConfigParam, getEmployeeParams } from '../../../../../../../utils/reducers/getters'
import ModalConfigTurnEmployeeOrder from './ModalConfigTurnEmployeeOrder'
import { EmployeesPayload } from '../../../../../../../utils/reducers/company/employees'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { VerticalSortItem } from '../../../../../../../baseComponents/Sorts/VerticalSortList/types'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'


type ModalConfigWCalTurnProps = ModalEditComponentProps & ModalConfigWCalTurnLogicProps & ReduxEmployees & {
}

const ModalConfigWCalTurn: React.FC<ModalConfigWCalTurnProps> = ({ userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const logic = useModalConfigWCalTurnLogic({ ...rest })
    const punchInWithWorkingCenter = useMemo(() => getConfigParam('punchInWithWorkingCenter') === 'on', [])

    const tabs: ComponentTabObject = {
        'main': { component: ModalConfigTurnEmployeeOrder, text: t('employeeOrder', 'Orden de los empleados') },
    }
    if (punchInWithWorkingCenter) {
        tabs['colors'] ={ component: ModalConfigTurnWCColors, text: t('assignColors', 'Definir colores') }

    }
    return (
        <ModalTabs userPermissions={userPermissions || {n: 4, permission: 'delete'}} {...rest} tabs={tabs} tab={'main'} className='notFlexAutoFormRender' extraComponentData={logic}></ModalTabs>
    )
}

interface ModalConfigWCalTurnLogicProps {
    setOpened: ModalOpenedSetTy
    onSubmit: OnSubmit
}
export interface WCalTurnConfigData {
    colors: { [id: number]: string }
    order: { [id: number]: VerticalSortItem }
}

const useModalConfigWCalTurnLogic = ({ setOpened, onSubmit }: ModalConfigWCalTurnLogicProps) => {
    const [selectedData, setSelectedData] = useState<WCalTurnConfigData>(JSON.parse(getEmployeeParams()?.['wcal_turn_config'] || '{}'))
    const { endLoading, loading, startLoading } = useIsLoading()
    const { t } = useTwinTranslation()
    const message = t('successfullyCompleted', 'Realizado correctamente')

    const updateEmployeeParams = useCallback(async (config: WCalTurnConfigData) => {
        let myConfig: TwinDictionary  = { colors: config.colors, order: {} }
        for (const key in config.order) {
            myConfig.order[key] = {order: config.order[key].order}
        }
        const myValue = JSON.stringify(myConfig)
        startLoading()
        const result = await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'wcal_turn_config', value: myValue })
        if (result) {
            changeSuccessMessage(message)
        }
        endLoading()
        changeEmployeeParams({ 'wcal_turn_config': myValue })
        return result
    }, [startLoading, endLoading, message])

    const onSave = useCallback(async () => {
        const res = await updateEmployeeParams(selectedData)
        setOpened(null)
        onSubmit?.(res, {})
        return false
    }, [setOpened, selectedData, updateEmployeeParams, onSubmit])

    return { selectedData, setSelectedData, onSave, loading }
}

const employeesDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

export type ReduxEmployees = ConnectedProps<typeof employeesConnect>
const mapEmployeesConnector = (state: AllReduxPayloads) => ({ employees: state.employees, employeeAbsenceTypes: state.employeeAbsenceTypes })
const employeesConnect = connect(mapEmployeesConnector, employeesDispatch)
const employeesConnectLoading = withLoading(ModalConfigWCalTurn, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const ModalConfigWCalTurnConnect = employeesConnect(employeesConnectLoading)

export default ModalConfigWCalTurnConnect